(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pz-goggle-finder"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',event=>{if(!event.target.matches('[data-pz-choice]'))return;const root=event.target.closest('[data-pz-finder]');const value=name=>root.querySelector('[data-pz-choice="'+name+'"]:checked')?.value;const goal=value('goal'),light=value('light'),tech=value('tech');if(!goal||!light||!tech)return;const key=goal==='speed'?'speed-'+tech:'flex-'+light+'-'+tech;const result=root.querySelector('[data-pz-finder-result="'+key+'"]');root.querySelector('[data-pz-finder-empty]').hidden=Boolean(result);root.querySelectorAll('[data-pz-finder-result]').forEach(card=>card.hidden=card!==result);});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pz-model-compare"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',event=>{if(!event.target.matches('[data-pz-compare-choice]'))return;const root=event.target.closest('[data-pz-comparison]');root.querySelector('[data-pz-compare-hint]').hidden=true;root.querySelectorAll('[data-pz-compare-result]').forEach(result=>result.hidden=result.dataset.pzCompareResult!==event.target.value);});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pz-retailer-map"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input',event=>{if(!event.target.matches('[data-pz-retailer-search]'))return;const root=event.target.closest('[data-pz-directory]'),normal=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase(),q=normal(event.target.value);let n=0;root.querySelectorAll('.pz-retailer-list article').forEach(a=>{a.hidden=!normal(a.textContent).includes(q);if(!a.hidden)n++;});root.querySelector('[data-pz-retailer-empty]').hidden=n>0;});
document.addEventListener('click',event=>{const button=event.target.closest('[data-pz-map-address]');if(!button)return;const root=button.closest('[data-pz-directory]');root.querySelectorAll('[data-pz-map-address]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));root.querySelector('[data-pz-selected-store]').textContent=button.querySelector('span').textContent;root.querySelector('iframe').src='https://maps.google.com/maps?q='+encodeURIComponent(button.dataset.pzMapAddress)+'&output=embed';});
  } catch(e) { console.error(e); }
})();

})();
